import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { FeedbackModalTemplate } from 'modals/Templates';

import { CustomPrimaryButton } from 'components/Buttons';

import { RetryErrorModalPropsType } from './types';

const RetryErrorModal = ({ img, title, subtitle, subject, retryAction }: RetryErrorModalPropsType) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const contactUsData = subject
        ? {
              subject,
              text: 'basics.contactSupport',
          }
        : null;

    return (
        <FeedbackModalTemplate image={img} title={title} subtitle={subtitle} contactUs={contactUsData} withCloseButton>
            <CustomPrimaryButton onClick={() => dispatch(retryAction())} mb={subject ? 16 : 0}>
                {t('basics.tryAgain')}
            </CustomPrimaryButton>
        </FeedbackModalTemplate>
    );
};

export default RetryErrorModal;
